import { Drawer } from "vaul";
import { cn } from "../../../lib/cn";

/**
 * MobileDrawer - A bottom sheet drawer for mobile using Vaul
 * 
 * This component provides a native-feeling mobile drawer that:
 * - Slides up from the bottom on mobile
 * - Can be dismissed by swiping down or tapping backdrop
 * - Prevents body scroll when open
 * - Uses snap points for partial visibility (optional)
 * 
 * @param {boolean} open - Whether the drawer is open
 * @param {function} onClose - Callback when drawer closes
 * @param {string} title - Optional title for the drawer header
 * @param {ReactNode} children - Content to render inside the drawer
 * @param {string} className - Additional classes for the content container
 */
export const MobileDrawer = ({
  open,
  onClose,
  title,
  children,
  className,
}) => {
  return (
    <Drawer.Root open={open} onOpenChange={onClose}>
      <Drawer.Portal>
        <Drawer.Overlay className="fixed inset-0 bg-black/40 z-drawer" />
        <Drawer.Content
          className={cn(
            "fixed bottom-0 left-0 right-0 z-drawer bg-white rounded-t-[20px] shadow-2xl",
            "flex flex-col max-h-[85vh]",
            className
          )}
        >
          {/* Handle bar */}
          <div className="flex justify-center pt-3 pb-1">
            <div className="w-10 h-1.5 rounded-full bg-surface-disabled" />
          </div>

          {/* Header */}
          {title && (
            <div className="px-4 pb-3 border-b border-surface-border">
              <h3 className="text-base font-semibold text-primary">{title}</h3>
            </div>
          )}

          {/* Content */}
          <div className="flex-1 overflow-y-auto px-4 py-4">
            {children}
          </div>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
};

export default MobileDrawer;
